"use strict"

import { HttpService } from "../http/http.service"

export default class IsteService {
  /**
   * @param {HttpService} HttpService
   */
  constructor($q, $log, environment, HttpService) {
    "ngInject"

    this.$q = $q
    this.$log = $log
    this._environment = environment
    /** @type {HttpService} */
    this._httpService = HttpService
  }

  /**
   * send ISTE details to new users
   *
   * @param classCode {string}
   * @param email {string}
   * @returns {Promise.<*>}
   */
  async sendIsteDetails(classCode, email) {
    if (!classCode) {
      throw new Error("Class code is required")
    }

    if (!email) {
      throw new Error("email is required")
    }

    if (typeof classCode !== "string") {
      throw new Error("Class code must be string")
    }

    if (typeof email !== "string") {
      throw new Error("email must be string")
    }

    try {
      return await this._httpService.authPost(this._uri(`/v1/iste/send`), {
        class_code: classCode,
        teacher_email: email,
      })
    } catch (error) {
      this.$log.error("Error sending ISTE details:", error)
      throw error
    }
  }

  /**
   * Returns a string that specifies a uri given a path.
   *
   * @param path {string}
   * @returns {string}
   * @private
   */
  _uri(path) {
    return `${this._environment.serverUrlBase}${path}`
  }
}
